import { getBootstrapModal } from './bootstrap-runtime';
import { initializeReCaptcha } from './recaptcha';

type LoginConfig = {
    useRecaptcha: boolean;
    loginLink: string;
    recaptchaFail: string;
    locale?: string;
};

function getRecaptchaResponse(): string {
    if (typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.getResponse !== 'function') {
        return '';
    }
    return window.grecaptcha.getResponse() || '';
}

export const initLogin = (
    useRecaptcha: boolean,
    loginLink: string,
    recaptchaText: string,
    useTotp: boolean,
): void => {
    $('#login').off('click.naisLogin').on('click.naisLogin', function (e: JQuery.ClickEvent) {
        e.preventDefault();
        let sendFormData = true;
        const data: Record<string, string | boolean | null> = {
            username: String($('#username').val()),
            password: String($('#password').val()),
            remember: $('#frm-signInForm-remember').is(':checked'),
            recaptcha: null,
            totpCode: null,
        };
        if (useRecaptcha) {
            data.recaptcha = getRecaptchaResponse();
            sendFormData = Boolean(data.recaptcha);
            $('#recaptchaMessage').text(sendFormData ? '' : recaptchaText);
        }
        if (useTotp) {
            data.totpCode = String($('#totpCode').val());
        }
        if (sendFormData) {
            $.nette.ajax({
                type: 'post',
                url: loginLink,
                data,
                success(response: { errorMessage?: string; showTokenModal?: boolean | string }) {
                    if (response.showTokenModal) {
                        const totpModal = document.getElementById('totpModal');
                        if (totpModal) {
                            getBootstrapModal().getOrCreateInstance(totpModal).show();
                        }
                        return;
                    }
                    if (!response.errorMessage) {
                        const form = document.getElementById('frm-signInForm');
                        if (form instanceof HTMLFormElement) {
                            form.submit();
                        }
                    }
                },
            });
        }
    });
};

window.initLogin = initLogin;

function getLoginConfig(): LoginConfig | null {
    if (window.__naisLogin) {
        return window.__naisLogin;
    }

    const configElement = document.getElementById('nais-login-config');
    if (!configElement) {
        return null;
    }

    try {
        return JSON.parse(configElement.textContent || '{}') as LoginConfig;
    } catch {
        return null;
    }
}

export function naisBootLogin(): void {
    const cfg = getLoginConfig();
    if (!cfg) {
        return;
    }
    if (cfg.useRecaptcha) {
        initializeReCaptcha(cfg.locale || document.documentElement.lang || 'cs');
    }
    initLogin(cfg.useRecaptcha, cfg.loginLink, cfg.recaptchaFail, false);
}

window.naisBootLogin = naisBootLogin;
